export const REGISTER_MEMBER_ENDPOINT = '/register-member';
